module.exports = __webpack_public_path__ + "static/img/tick.f23123f5.svg";